import * as React from "react";
import ProductModel from "../domain/Product";
import "./Product.css";
import calculatePrice from "../domain/calculatePrice";
import { formatPrice } from "./formatNumber";

interface Props {
  product: ProductModel;
  userDiscount: number;
}

class Product extends React.PureComponent<Props> {
  public render(): JSX.Element {
    const rowClasses = "product-details-row";
    return (
      <div className={rowClasses}>
        <div className="product-image">
          <img
            src={
              this.props.product.image
                ? `https://media.happysocks.com/images/${
                    this.props.product.image
                  }`
                : `https://media.happysocks.com/images/${
                    this.props.product.articleId
                  }_FLAT_colect_thumb.jpg`
            }
            alt={this.props.product.name}
          />
        </div>
        <div className="product-name">
          <span>{this.props.product.name}</span>
        </div>
        <div className="product-package">
          <span>{this.props.product.packageSize} pcs</span>
        </div>
        <div className="product-userPrice">
          <span>
            {formatPrice(
              calculatePrice(
                this.props.product.wholesalePrice,
                this.props.userDiscount,
                this.props.product.discountCodeASet
              )
            )}
          </span>
        </div>
        <div className="product-sku">
          <div className="badge">{this.props.product.articleId}</div>
        </div>
      </div>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/view/Product.tsx